import React, { useContext, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router';
import { IonContent, IonCard, IonCardContent, IonGrid, IonRow, IonCol } from '@ionic/react';

// Components
import { HeaderComponent, QrScanComponent } from '../../../components';

// Helpers
import { extractConfigPage } from '../../../helpers';

// Contexts
import { AppContext } from '../../../contexts';

// Validators
import { RoutesValidator } from './../../../validators';

// Scss
import './QrScanPage.scss';

export const QrScanPage = ({menuRef, userPermission}) => {

    const history = useHistory();
    const location = useLocation();
    const pageConfig = extractConfigPage(location);
    const { isWeb } = useContext(AppContext);

    useEffect(() => {

        RoutesValidator.validatePageQrScan(history, pageConfig);

    }, []);
    
    return (
        <>
            <HeaderComponent
                title={pageConfig.title}
                menuRef={menuRef}
            />

            <IonContent className="ion-padding">

                {/* MOBILE */}
                {!isWeb &&

                    <QrScanComponent
                        pageConfig={pageConfig}
                        history={history}
                        userPermission={userPermission}
                    />
                }

                {/* WEB */}
                {
                    isWeb &&
                    <IonGrid>
                        <IonRow className='ion-text-left'>
                            <IonCol>
                                <h1>Código QR</h1>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonCard>
                                    <IonCardContent className="ion-text-center">

                                        <QrScanComponent
                                            pageConfig={pageConfig}
                                            history={history}
                                            userPermission={userPermission}
                                        />

                                    </IonCardContent>
                                </IonCard>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                }

            </IonContent>
        </>
    )
}
